import ColumnSlider from "./utils/ColumnSlider";
import VoiceSlider from "./utils/VoiceSlider";
import PhotoSlider from "./utils/PhotoSlider";
import ProgramSlider from "./utils/ProgramSlider";
import { accordion } from "./utils/accordion";
import { modal } from "./utils/modal";
import { header } from "./utils/header";
import { fadeIn } from "./utils/fadeIn";

class Main {
  constructor() {
    new ColumnSlider();
    new VoiceSlider();
    new PhotoSlider();
    new ProgramSlider();
    accordion();
    modal();
    header();
    fadeIn();
  }
}

window.addEventListener("DOMContentLoaded", () => {
  new Main();
});
